import { makeStyles } from '@material-ui/core/styles';

/**
 * Estilos para la página de bienvenida del módulo IA
 */
export const iaWelcomeStyles = makeStyles((theme) => ({
    // ============================================
    // Layout Principal
    // ============================================
    root: {
        padding: theme.spacing(4, 6),
        maxWidth: 1200,
        margin: '0 auto',
        position: 'relative',
    },

    // ============================================
    // Hero Section
    // ============================================
    heroSection: {
        position: 'relative',
        marginBottom: theme.spacing(6),
    },
    heroDecoration: {
        position: 'absolute',
        top: -40,
        left: -40,
        width: 250,
        height: 250,
        background: 'rgba(139, 92, 246, 0.08)',
        borderRadius: '50%',
        filter: 'blur(60px)',
        zIndex: 0,
    },
    heroContent: {
        position: 'relative',
        zIndex: 1,
    },
    title: {
        fontWeight: 900,
        fontSize: '2.5rem',
        color: '#1e1b4b',
        letterSpacing: '-0.02em',
        marginBottom: theme.spacing(2),
    },
    titleAccent: {
        color: '#8b5cf6',
    },
    subtitle: {
        fontSize: '1.1rem',
        color: '#6b7280',
        lineHeight: 1.7,
        maxWidth: 600,
    },
    subtitleBold: {
        color: '#1e1b4b',
        fontWeight: 600,
    },

    // ============================================
    // Section Headers
    // ============================================
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
        gap: theme.spacing(2),
    },
    sectionTitle: {
        fontSize: '0.7rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        color: '#9ca3af',
        whiteSpace: 'nowrap',
    },
    sectionDivider: {
        flex: 1,
        height: 1,
        backgroundColor: '#e5e7eb',
    },

    // ============================================
    // Agent Cards
    // ============================================
    card: {
        padding: theme.spacing(3),
        borderRadius: 24,
        border: '1px solid #f3f4f6',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
            boxShadow: '0 20px 40px rgba(139, 92, 246, 0.1)',
            transform: 'translateY(-2px)',
        },
        '&:hover $cardDecoration': {
            transform: 'scale(1)',
        },
        '&:hover $iconContainer': {
            backgroundColor: '#8b5cf6',
            color: '#ffffff',
        },
    },
    cardDecoration: {
        position: 'absolute',
        top: -32,
        right: -32,
        width: 96,
        height: 96,
        backgroundColor: 'rgba(139, 92, 246, 0.05)',
        borderRadius: '50%',
        transform: 'scale(0)',
        transition: 'transform 0.5s ease',
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    iconContainer: {
        padding: theme.spacing(1.5),
        backgroundColor: 'rgba(139, 92, 246, 0.08)',
        color: '#8b5cf6',
        borderRadius: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        fontSize: '1.8rem',
    },
    cardTitleGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    cardTitle: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#1e1b4b',
    },
    badge: {
        fontSize: '0.6rem',
        fontWeight: 700,
        backgroundColor: '#dcfce7',
        color: '#15803d',
        borderRadius: 20,
        height: 18,
    },
    cardDescription: {
        fontSize: '0.85rem',
        color: '#6b7280',
        lineHeight: 1.6,
        marginBottom: theme.spacing(3),
    },
    cardFooter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: '1px solid #f9fafb',
        paddingTop: theme.spacing(2),
    },
    lastUsedText: {
        fontSize: '0.65rem',
        color: '#9ca3af',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    openButton: {
        color: '#8b5cf6',
        fontWeight: 700,
        fontSize: '0.8rem',
        textTransform: 'none',
        padding: 0,
        minWidth: 'auto',
        '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'none',
        },
    },
}));
